import { requireDashboardOrigin } from "@api/features/dashboard-auth/origin/dashboardOriginGuard"
import { serverRouteConfig } from "@server/serverRouteConfig"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/api/dashboard/auth/logout")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const originError = requireDashboardOrigin(request)
          if (originError) return originError

          const { logoutDashboardResponse } = await import("@api/features/dashboard-auth/dashboardAuthApi")
          return logoutDashboardResponse()
        },
      },
    },
  })
)
